document.addEventListener('click', function (event) {
  const swatch = event.target.closest(
    '.makage-card-swatches button[data-makage-image]'
  );

  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();

  const card = swatch.closest('.product-card-wrapper');
  const image = card?.querySelector(
    '.card__media .media > img:first-child'
  );

  if (!image) return;

  // Verhindert, dass weiterhin das alte responsive Bild erscheint.
  image.removeAttribute('srcset');
  image.removeAttribute('sizes');
  image.src = swatch.dataset.makageImage;
  image.alt = swatch.dataset.makageAlt;

  card.classList.add('makage-color-selected');

  card.querySelectorAll('.makage-card-swatch').forEach(function (item) {
    item.classList.remove('is-active');
    item.removeAttribute('aria-pressed');
  });

  swatch.classList.add('is-active');
  swatch.setAttribute('aria-pressed', 'true');
});/* MAKAGE – Produkt beim Klick auf das Bild öffnen */
document.addEventListener('click', function (event) {
  if (!(event.target instanceof Element)) return;

  const imageArea = event.target.closest(
    '.product-card-wrapper .card__inner'
  );

  if (!imageArea || !imageArea.querySelector('.card__media')) return;

  if (event.target.closest('a, button, input, select, textarea')) return;
  if (event.defaultPrevented) return;

  const card = imageArea.closest('.product-card-wrapper');
  const productLink = card.querySelector('.card__heading a[href]');

  if (productLink) {
    window.location.assign(productLink.href);
  }
});